<template>
	<v-menu
		ref="menu"
		v-model="menu"
		:close-on-content-click="false"
		:nudge-right="40"
		:return-value.sync="localValue"
		transition="scale-transition"
		offset-y
		max-width="290px"
		min-width="290px"
		:hide-details="hideDetails"
		naked
	>
		<template v-slot:activator="{ on, attrs }">
			<v-text-field
				v-model="localValue"
				:label="label"
				prepend-icon="mdi-clock"
				:hide-details="hideDetails"
				readonly
				naked
				v-bind="attrs"
				v-on="on"
			></v-text-field>
		</template>
		<v-time-picker
			v-if="menu"
			v-model="localValue"
			full-width
			@click:minute="$refs.menu.save(localValue)"
			v-bind="$attrs"
			@click:hour="(...args) => $emit('click:hour', ...args)"
		></v-time-picker>
	</v-menu>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
import AtomsMixins from './common/atoms.mixin';

export default {
	name: 'AppTimePickerMenu',
	mixins: [VModelMixin, AtomsMixins],
	props: {
		label: { type: String },
	},
	data() {
		return {
			menu: false,
		};
	},
};
</script>

<style scoped lang="scss"></style>
